import { PetCostsPage } from '@web/components/pet-costs-page';
import { PetCostsScreenProps } from 'shared/screens/pet-costs';
import { withServerProps } from '@web/library/with-server-props';

export default function DogCosts(props: PetCostsScreenProps) {
  return <PetCostsPage {...props} animal={'dog'} />;
}

export const getServerSideProps = withServerProps();
